import { gatewayUrl } from "@Constants/gatewayUrl";
import { createConfig } from "@Utils/createConfig";
import axios from "axios";
export function fetchAvailableConnections(token) {
    return axios.post(`${gatewayUrl}/chats/connections/available`, {
        lawsuitId: null
    }, createConfig(token)).then(({ data })=>data);
}
export function postUsageMeterUpgrade(token) {
    return axios.post(`${gatewayUrl}/usage-meter/upgrade`, {}, createConfig(token)).then(({ data })=>data);
}
export function fetchUsageMeterStatus(token) {
    return axios.get(`${gatewayUrl}/usage-meter`, createConfig(token)).then(({ data })=>data);
}
